/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import {PersonType} from "types/enums/PersonType";
import {Package} from "types/entities/Package";
import {findPackageItemByPersonType, isAction, isEvent, isGiftCard} from "utils/packageUtils";
import {PackageItemPersonType} from "types/enums/PackageItemPersonType";
import {BookingFilter} from "types/app";
import {UseFormSetValue} from "react-hook-form/dist/types";
import {useTypedSelector} from "helpers/reducers";
import Loader from "components/Loader";
import BookingCardTitle from "pages/Front/Booking/components/BookingCardTitle";
import DriversCountFilterItemNew from "pages/Front/Booking/components/BookingFilters/DriversCountFilterItemNew";
import {PackageCategory} from "types/enums/PackageCategory";

interface DriversCountFilterNewProps {
    showTitle: boolean;
    isMinimalistic: boolean;
    register: any;
    setValue: UseFormSetValue<BookingFilter>;
    watch: any;
    onChange: (type: string, value: number) => void;
    selectedPackage?: Package | null;
}

const DriversCountFilterNew = (props: DriversCountFilterNewProps) => {
    const hall = useTypedSelector(state => state.hallState.hall);
    const bookingFilter = useTypedSelector(state => state.bookingState.bookingProcess.filter);
    const adultsDisabled = props.selectedPackage && findPackageItemByPersonType(props.selectedPackage.packageItems, PackageItemPersonType.Adult);
    const isPackageGiftCard = props.selectedPackage ? isGiftCard(props.selectedPackage) : false;
    const isPackageEvent = props.selectedPackage ? isEvent(props.selectedPackage) : false;
    // desighned for FamilyTickets
    const isPackageAction = props.selectedPackage ? isAction(props.selectedPackage) : false;

    const eventsCategories = [PackageCategory.Event, PackageCategory.EventS, PackageCategory.EventM, PackageCategory.EventL];
    const isCategoryEvent: boolean = !!(bookingFilter?.category && eventsCategories.includes(bookingFilter.category));
    const isCategoryFamilyTicket =
        bookingFilter.category === PackageCategory.Action ||
        bookingFilter.category === PackageCategory.SchoolTrophy ||
        bookingFilter.category === PackageCategory.MegaFunSchool ||
        bookingFilter.category === PackageCategory.FerienPass ||
        bookingFilter.category === PackageCategory.FerienPassB ||
        bookingFilter.category === PackageCategory.HappyKids ||
        bookingFilter.category === PackageCategory.HappyKidsPlus ||
        bookingFilter.category === PackageCategory.Kinder;
    const isCategoryGift = bookingFilter.category === PackageCategory.Giftcard;

    if (!hall) {
        return <Loader />;
    }

    return (
        <div className={"DriversCountFilterNew flex flex-col space-y-4 overflow-hidden"}>
            {props.showTitle && !isPackageEvent && (
                <BookingCardTitle className={"mb-3"} title={isPackageGiftCard ? "Number of giftcards" : "Number of people"} />
            )}
            <div className={"WithoutPackageSelected space-y-4 sm:space-y-4 !mt-0"}>
                <DriversCountFilterItemNew
                    disabled={bookingFilter.category === PackageCategory.FerienPassB}
                    isAction={isCategoryFamilyTicket}
                    isEvent={isCategoryEvent}
                    isGiftCard={isCategoryGift}
                    isMinimalistic={props.isMinimalistic}
                    name="adults"
                    personType={PersonType.Adult}
                    register={props.register}
                    selectedPackage={props.selectedPackage}
                    setValue={props.setValue}
                    watch={props.watch}
                    onChange={props.onChange}
                />
                {isCategoryFamilyTicket && (
                    <DriversCountFilterItemNew
                        isAction={isCategoryFamilyTicket}
                        isEvent={isCategoryEvent}
                        isGiftCard={isCategoryGift}
                        // disabled={typeof childrenDisabled == "undefined" || childrenDisabled == null}
                        isMinimalistic={props.isMinimalistic}
                        name="children"
                        personType={PersonType.Child}
                        register={props.register}
                        selectedPackage={props.selectedPackage}
                        setValue={props.setValue}
                        watch={props.watch}
                        onChange={props.onChange}
                    />
                )}
            </div>
        </div>
    );
};

export default DriversCountFilterNew;
